// extracted by mini-css-extract-plugin
export default {"root":"FormItem_root__7ut+U"};